import { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import config from '../lib/config';

interface IProps {
  count: number;
  page: number;
  param?: any; // mutable object
  path?: string;
  setPage?: (page: number) => void;
  perPage?: number;
  mini?: boolean;
  small?: boolean;
  levelupMini?: boolean;
}

const Pagination: FC<IProps> = ({
  count,
  page,
  param,
  path,
  setPage = null,
  perPage = 0,
  mini = false,
  small = false,
  levelupMini = false,
}) => {
  const history = useHistory();
  const pageButtons = config.pageButtons; //10
  let pageSize = config.pageSize; //20
  if (mini) pageSize = config.miniPageSize;
  else if (small) pageSize = config.smallPageSize;
  else if (levelupMini) pageSize = config.minimumPageSize;

  pageSize = perPage ? perPage : pageSize;

  const [endPage, setEndPage] = useState(
    Math.ceil(page / pageButtons) * pageButtons,
  ); //20
  const [startPage, setStartPage] = useState(endPage - pageButtons + 1);
  const [lastPage, setLastPage] = useState(0);

  useEffect(() => {
    setLastPage(Math.ceil(count / pageSize));
  }, [count, page]);

  useEffect(() => {
    onSetPage(page);
  }, [page]);

  const onSetPage = (page: number) => {
    if (page > lastPage) return;

    const endPage = Math.ceil(page / pageButtons) * pageButtons;
    setEndPage(endPage);
    setStartPage(endPage - pageButtons + 1);

    // 모달 페이지네이션
    if (setPage) {
      setPage(page);
      // 일반 페이지네이션
    } else {
      param.page = page;
      history.push(`${path}?${qs.stringify(param)}`);
    }
  };

  return (
    <ul>
      {/* left button */}
      {lastPage !== 0 && !isNaN(lastPage) && page > pageButtons ? (
        <li onClick={() => onSetPage(startPage - 1)}>
          <button className="btn-prev" />
        </li>
      ) : null}

      {/* page buttons */}
      {[...Array(endPage - startPage + 1)].map((n, index) => {
        if (startPage + index > lastPage) return null;

        return (
          <li
            key={index}
            onClick={() => onSetPage(startPage + index)}
          >
            <a className={(page - startPage - index === 0 ? ' active' : ' pointer')}>{startPage + index}</a>
          </li>
        );
      })}

      {/* right button */}
      {page !== lastPage && endPage + 1 <= lastPage ? (
        <li onClick={() => onSetPage(endPage + 1)}>
          <button className="btn-next" />
        </li>
      ) : null}
    </ul>
  );
};

export default Pagination;
